export default __webpack_public_path__ + "static/media/dotBar.98799fbd.svg";